var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4L8.18694 25.3757C7.48932 26.2128 7.14052 26.6314 7.13518 26.9849C7.13055 27.2922 7.26749 27.5846 7.50654 27.7778C7.78153 28 8.32638 28 9.4161 28H24L22 44L39.8131 22.6243C40.5107 21.7872 40.8595 21.3686 40.8649 21.0151C40.8695 20.7078 40.7326 20.4154 40.4935 20.2222C40.2185 20 39.6737 20 38.584 20H24L26 4Z",
    stroke: "#01758C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.bf75fe3a69ae3c94b4741ab0c63c2dc1.svg";
export { ForwardRef as ReactComponent };